<template v-if="isLoaded">
  <Menu as="div" class="relative">
    <MenuButton class="flex items-center transition rounded-lg group">
      <div
        class="group grid place-content-center w-9 h-9 rounded-full bg-white border-[1px] border-gray-200 text-gray-200"
        :class="notifications.filter((notification: any) => !notification.read).length > 0 && 'border-blue-3 hover:border-blue-3 hover:bg-blue-3 hover:bg-opacity-10'"
      >
        <i
          class="fas fa-bell"
          :class="notifications.filter((notification: any) => !notification.read).length > 0 && 'text-blue-1'"
        ></i>

        <span
          class="absolute top-0 right-0 w-4 h-4 text-[8px] text-white bg-[#7678FF] rounded-full grid place-content-center"
          v-if="notifications.filter((notification: any) => !notification.read).length > 0"
        >
          {{
            notifications.filter((notification: any) => !notification.read)
              .length
          }}
        </span>
      </div>
    </MenuButton>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="absolute right-1/2 left-1/2 transform -translate-x-1/2 lg:right-0 lg:left-auto lg:translate-x-0 mt-2 w-max max-w-sm md:max-w-md max-h-[80vh] origin-top-right divide-y text-gray-900 divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-auto"
      >
        <NotificationsList :notifications="notifications" />
      </MenuItems>
    </transition>
  </Menu>
</template>
<script setup lang="ts">
import { Menu, MenuButton, MenuItems } from "@headlessui/vue";
import { computed } from "@vue/reactivity";
import { onMounted, onUnmounted, ref, watch } from "vue";
import { useStore } from "vuex";
import NotificationsList from "@/features/notifications/components/NotificationsList.vue";
import { TYPES } from "@/types";
import { myContainer } from "@/inversify.config";
import { ISignalRService } from "@/interfaces/ISignalR";
import { INotificationItem, NotificationItem } from "../models/Notifications";
import { NotificationBaseResponse } from "@/features/shared/models/NotificationBaseResponse";
import { SendMessageCommandResponse } from "@/features/shared/models/SendMessageCommandResponse";
import { MessageResponse } from "../../messaging/models/Message";
import { Callback } from "../../../models/signalr/SignalRBuilder";
import router from "@/router";
import { ApplicantPositionResponse, EditableSkill } from "../../../models/dtos";
import { Container } from "inversify";
const signalRClient = myContainer.get<ISignalRService>(TYPES.ISignalRService);

const store = useStore();
const isLoaded = ref(false);
let signalRCallback: string | null = null;
const initSignalR = () => {
  signalRCallback = signalRClient.registerCallback(
    (message: INotificationItem) => {
      if (message.type === "Exception") {
        const payload = message as NotificationBaseResponse<string>;
        payload.callback = () => {
          router.push({
            name: "notificationItem",
            params: {
              id: message.id,
            },
          });
        };
        store.dispatch("addNotificationItem", payload);
      } else if (message.type === "send_MessageCommand") {
        const payload =
          message as NotificationBaseResponse<SendMessageCommandResponse>;
        store.dispatch("addNotificationItem", payload);
      } else if (message.type === "create_jobApplication") {
        const payload =
          message as NotificationBaseResponse<SendMessageCommandResponse>;
        payload.callback = () => {
          router.push(
            "/admin/positions/" +
              message.data.positionId +
              "/applicants/" +
              message.data.id
          );
        };
        store.dispatch("addNotificationItem", payload);
      } else if (message.type === "update_jobApplicationStatus") {
        const payload =
          message as NotificationBaseResponse<ApplicantPositionResponse>;
        payload.callback = () => {
          router.push(
            "/admin/positions/" +
              message.data.positionId +
              "/applicants/" +
              message.data.id
          );
        };
        store.dispatch("addNotificationItem", payload);
      } else {
        const payload = message as NotificationBaseResponse<object>;
        payload.callback = () => {
          router.push({
            name: "notificationItem",
            params: {
              id: message.id,
            },
          });
        };
        store.dispatch("addNotificationItem", payload);
      }
    }
  );
};

watch(
  () => store.getters.container,
  (newValue: number, oldValue) => {
    init();
  }
);
const init = async () => {
  initSignalR();
  await signalRClient.test(store.getters.container.id, store.getters.token);
  await signalRClient.start();
  isLoaded.value = true;
};
onUnmounted(() => {
  signalRClient.removeCallback(signalRCallback);
});
onMounted(async () => {
  await store.dispatch("loadNotifications");

  const containerId = store.getters.container.id;
  if (containerId) init();
});

const notifications = computed(() => {
  return store.getters.notifications;
});
</script>
